export const selectStyle = () => ({
  control: (provided, state) => ({
    ...provided,
    borderRadius: "4px",
    backgroundColor: "#fff",
    height: "30px",
    border: "1px solid #b2bcc6",
    marginBottom: 0,
    padding: 0,
    minHeight: "30px"
  }),
  container: (provided, state) => ({
    ...provided,
    width: "8.25rem"
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "100%",
    padding: "0 0 0 .5rem",
    width: "120px"
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    display: "none"
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    display: "none"
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: "none"
  }),
  input: (provided, state) => ({
    height: "100%",
    boxShadow: "none"
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: ".75rem",
    color: "#b2bcc6",
    fontWeight: 300
  }),
  menuList: (provided, state) => ({
    ...provided,
    paddingTop: "0",
    paddingBottom: "0",
    color: "#6D7F92"
  }),
  menu: (provided, state) => ({
    ...provided,
    borderRadius: "4px",
    //height: "15rem",
    top: "1.5rem",
    zIndex: 3,
    //backgroundColor: "#F1F2F4",
    overflow: "hidden",
    padding: ".5rem 0",
    border: "none"
  }),
  option: (provided, state) => ({
    ...provided,
    textAlign: "left",

    backgroundColor: state.isFocused ? "#F8F9FA" : "transparent",
    color: "#6D7F92"
  }),
  singleValue: (provided, state) => ({
    ...provided,
    position: "relative",
    transform: "none",
    top: "0"
  }),
  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: "rgba(47, 71, 194, .75)",
    color: "#fff"
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    fontSize: ".9rem",
    color: "#fff"
  })
});

export const singleValueStyle = () => ({
  display: "flex",
  alignItems: "center"
});



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Filter/Condition/SelectStyle.js